(() => {
  let request;
  const selector = "[data-collection-root]";

  const preserveAlternateView = (input) => {
    const url = new URL(input, location.href);
    const view = new URL(location.href).searchParams.get("view");
    if (view && !url.searchParams.has("view")) url.searchParams.set("view", view);
    return url;
  };

  const bindMediaFallbacks = (root = document) => {
    const label = root.matches?.(selector)
      ? root.dataset.mediaErrorLabel
      : root.querySelector(selector)?.dataset.mediaErrorLabel;
    root.querySelectorAll?.(".product-card__media img").forEach((image) => {
      const media = image.closest("[data-product-media]");
      const status = media?.querySelector("[data-product-media-status]");
      const renderedFallback = media?.querySelector("[data-product-media-fallback]");
      const finishLoading = () => {
        media?.removeAttribute("aria-busy");
        if (status) status.textContent = "";
      };
      const showFallback = () => {
        if (!image.isConnected) return;
        finishLoading();
        if (renderedFallback) {
          renderedFallback.hidden = false;
          image.remove();
          return;
        }
        const genericFallback = document.createElement("span");
        genericFallback.className = "product-card__no-media";
        genericFallback.textContent = label || image.alt;
        image.replaceWith(genericFallback);
      };
      image.addEventListener("load", finishLoading, { once: true });
      image.addEventListener("error", showFallback, { once: true });
      if (image.complete) {
        if (image.naturalWidth === 0) showFallback();
        else finishLoading();
      }
    });
  };

  const updateChipState = (root, selectedUrl) => {
    const selected = new URL(selectedUrl, location.href);
    root.querySelectorAll("[data-collection-chip]").forEach((chip) => {
      const chipUrl = new URL(chip.href, location.href);
      const isActive = chipUrl.pathname === selected.pathname;
      chip.classList.toggle("is-active", isActive);
      if (isActive) chip.setAttribute("aria-current", "page");
      else chip.removeAttribute("aria-current");
    });
  };

  const replaceDynamicCollection = (current, next, url) => {
    const currentToolbar = current.querySelector(".collection-toolbar");
    const nextToolbar = next.querySelector(".collection-toolbar");
    const currentResults = current.querySelector('[aria-labelledby="CollectionResultCount"]');
    const nextResults = next.querySelector('[aria-labelledby="CollectionResultCount"]');
    if (!currentToolbar || !nextToolbar || !currentResults || !nextResults) return false;

    const currentActiveFilters = current.querySelector(".active-filters");
    const nextActiveFilters = next.querySelector(".active-filters");
    currentToolbar.replaceWith(nextToolbar);
    if (currentActiveFilters && nextActiveFilters) currentActiveFilters.replaceWith(nextActiveFilters);
    else if (currentActiveFilters) currentActiveFilters.remove();
    else if (nextActiveFilters) nextToolbar.closest(".page-width")?.append(nextActiveFilters);
    currentResults.replaceWith(nextResults);
    current.dataset.collectionSource = url.href;
    updateChipState(current, url);
    return true;
  };

  const replaceCollection = async (url, push, preserveShell = false) => {
    const current = document.querySelector(selector);
    if (!current) return;
    url = preserveAlternateView(url);
    request?.abort();
    const controller = new AbortController();
    request = controller;
    current.setAttribute("aria-busy", "true");
    const status = current.querySelector("[data-collection-status]");
    if (status) status.textContent = current.dataset.loadingLabel;
    try {
      const response = await fetch(url, { headers: { Accept: "text/html" }, signal: controller.signal });
      if (!response.ok) throw new Error(String(response.status));
      const result = new DOMParser().parseFromString(await response.text(), "text/html");
      const next = result.querySelector(selector);
      if (!next) throw new Error("Invalid collection response");
      const keptShell = preserveShell && replaceDynamicCollection(current, next, url);
      const rendered = keptShell ? current : next;
      if (!keptShell) {
        document.title = result.title || document.title;
        current.replaceWith(next);
      } else {
        current.removeAttribute("aria-busy");
      }
      bindMediaFallbacks(rendered);
      document.dispatchEvent(new CustomEvent("seifen:wishlist:init", { detail: { root: rendered } }));
      if (push) history.pushState({ collection: true, preserveShell: keptShell }, "", url);
      const heading = rendered.querySelector("[data-results-heading]");
      heading?.setAttribute("tabindex", "-1");
      heading?.focus();
    } catch (error) {
      if (error.name === "AbortError") return;
      current.removeAttribute("aria-busy");
      if (status) {
        status.textContent = current.dataset.errorLabel;
        status.classList.add("error");
      }
      const retry = current.querySelector("[data-collection-retry]");
      if (retry) retry.hidden = false;
    }
  };

  document.addEventListener("submit", (event) => {
    const form = event.target.closest("[data-collection-form]");
    if (!form) return;
    event.preventDefault();
    const url = new URL(form.action, location.href);
    new FormData(form).forEach((value, key) => url.searchParams.append(key, String(value)));
    replaceCollection(url, true, Boolean(document.querySelector(`${selector}[data-collection-source]`)));
  });
  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-collection-sort]")) event.target.form?.requestSubmit();
  });
  document.addEventListener("click", (event) => {
    const chip = event.target.closest("[data-collection-chip]");
    if (chip) {
      event.preventDefault();
      replaceCollection(chip.href, true, true);
      return;
    }
    const link = event.target.closest("[data-collection-link]");
    if (link) {
      event.preventDefault();
      replaceCollection(link.href, true, Boolean(document.querySelector(`${selector}[data-collection-source]`)));
    }
    const retry = event.target.closest("[data-collection-retry]");
    if (retry) replaceCollection(location.href, false);
  });
  addEventListener("popstate", (event) => {
    if (document.querySelector(selector)) replaceCollection(location.href, false, Boolean(event.state?.preserveShell));
  });
  bindMediaFallbacks();
})();
